import api from './api';

const service = {
    async searchBGroupList(aggregator_id, params) {
        return await api.get(`/aggregators/${aggregator_id}/bgroup_pplant/hp/`, { params:{area_id:params.area_id,target_date:params.targetDate} });
    },
    async searchForecastDataByArea(aggregator_id, area_id, targetDate) {
        return await api.get(`/aggregators/${aggregator_id}/areas/${area_id}/dates/${targetDate}/electric_power/forecast_hp`);
    },
    async searchForecastDataByBGroup(aggregator_id, bgroup_id, targetDate) {
        return await api.get(`/aggregators/${aggregator_id}/balancing_groups/${bgroup_id}/dates/${targetDate}/electric_power/forecast_hp`);
    },
    async searchForecastDataByPPlant(aggregator_id, pplant_id, targetDate) {
        return await api.get(`/aggregators/${aggregator_id}/power_plants/${pplant_id}/dates/${targetDate}/electric_power/forecast_hp`);
    },
    async searchForecastDataByResource(aggregator_id, resource_id, targetDate) {
        return await api.get(`/aggregators/${aggregator_id}/resources/${resource_id}/dates/${targetDate}/electric_power/forecast_hp`);
    },
}

export default service;
